import React, { useState } from "react";
import PropTypes from "prop-types";
import getDistance from "geolib/es/getDistance";
import CompactCard from "./CompactCard";
import AddRestaurantCTA from "./AddRestaurantCTA";
import EmptyState from "./EmptyState";
import MobileFooter from "./MobileFooter";
import "./CompactList.css";

const CompactList = ({
  restaurants,
  currentLocation,
  selectedRestaurantId,
  onRestaurantSelect,
  onAdHocSearch,
  searchQuery,
}) => {
  // Track which restaurant is expanded (accordion style - only one at a time)
  const [expandedId, setExpandedId] = useState(null);

  // Sort restaurants by distance
  const sortedRestaurants = [...restaurants].sort((a, b) => {
    const distA = getDistance(currentLocation, a.geoJson.coordinates);
    const distB = getDistance(currentLocation, b.geoJson.coordinates);
    return distA - distB;
  });

  const handleCardClick = (restaurant) => {
    if (expandedId === restaurant._id) {
      // Already expanded - collapse it
      setExpandedId(null);
    } else {
      // Expand this one (collapses any other)
      setExpandedId(restaurant._id);
      // Also select it
      onRestaurantSelect(restaurant._id, restaurant);
    }
  };

  if (!restaurants || restaurants.length === 0) {
    return <EmptyState onAdHocSearch={onAdHocSearch} />;
  }

  return (
    <div className="compact-list">
      {sortedRestaurants.map((restaurant) => (
        <CompactCard
          key={restaurant._id}
          restaurant={restaurant}
          currentLocation={currentLocation}
          isSelected={restaurant._id === selectedRestaurantId}
          isExpanded={restaurant._id === expandedId}
          onClick={() => handleCardClick(restaurant)}
          searchQuery={searchQuery}
        />
      ))}
      {/* CTA at bottom of list */}
      <AddRestaurantCTA variant="list" onAdHocSearch={onAdHocSearch} />
      {/* Footer */}
      <MobileFooter />
    </div>
  );
};

CompactList.propTypes = {
  restaurants: PropTypes.array.isRequired,
  currentLocation: PropTypes.object.isRequired,
  selectedRestaurantId: PropTypes.string,
  onRestaurantSelect: PropTypes.func,
  onAdHocSearch: PropTypes.func,
};

export default CompactList;
